import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../../firebase-config';
import { collection, addDoc, query, where, getDocs, serverTimestamp } from 'firebase/firestore';
import '../../login.css';

function SignupPage() {
  const [formData, setFormData] = useState({
    email: '',
    displayName: '',
    reason: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.email) {
      setError('Email address is required.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);

    try {
      // Block duplicate pending requests for the same email
      const q = query(
        collection(db, 'access_requests'),
        where('email', '==', formData.email.toLowerCase()),
        where('status', '==', 'pending')
      );
      const existing = await getDocs(q);
      if (!existing.empty) {
        setError('A request from this email is already pending review.');
        setLoading(false);
        return;
      }

      // Write access request — no Firebase Auth account created
      await addDoc(collection(db, 'access_requests'), {
        email: formData.email.toLowerCase(),
        displayName: formData.displayName || '',
        reason: formData.reason || '',
        status: 'pending',
        requestedAt: serverTimestamp(),
      });

      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-brand">
            <div className="login-brand-name">R A M D E S I G N W O R K S</div>
            <div className="login-brand-sub">Client Analytics Platform</div>
          </div>
          <div className="login-panel" style={{ textAlign: 'center' }}>
            <div className="login-rule" style={{ margin: '0 auto 24px' }} />
            <div style={{ fontSize: '2.4rem', marginBottom: '16px' }}>✓</div>
            <div className="login-panel-title">Request Received</div>
            <div className="login-panel-sub" style={{ maxWidth: '320px', margin: '0 auto 8px' }}>
              Your request has been submitted. A team member will review it and reach out to <strong style={{ color: 'rgba(0,210,255,0.9)' }}>{formData.email}</strong> with next steps.
            </div>
          </div>
          <div className="login-footer">© 2026 R A M D E S I G N W O R K S — Authorized access only.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">

        <div className="login-brand">
          <div className="login-brand-name">R A M D E S I G N W O R K S</div>
          <div className="login-brand-sub">Client Analytics Platform</div>
        </div>

        <div className="login-panel">
          <div className="login-rule" />
          <div className="login-panel-title">Request Access</div>
          <div className="login-panel-sub">Submit your information and a team member will review your request.</div>

          {error && <div className="login-error">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <label htmlFor="displayName" className="login-label">Full Name <span style={{opacity:0.5}}>(optional)</span></label>
              <input
                type="text"
                id="displayName"
                name="displayName"
                value={formData.displayName}
                onChange={handleChange}
                placeholder="John Doe"
                className="login-input"
              />
            </div>

            <div className="login-field">
              <label htmlFor="email" className="login-label">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="your@email.com"
                className="login-input"
                required
              />
            </div>

            <div className="login-field">
              <label htmlFor="reason" className="login-label">How do you know us? <span style={{opacity:0.5}}>(optional)</span></label>
              <input
                type="text"
                id="reason"
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                placeholder="Referral, social media, etc."
                className="login-input"
              />
            </div>

            <button type="submit" disabled={loading} className="login-btn">
              {loading ? 'Submitting...' : 'Submit Request'}
            </button>
          </form>

          <div className="login-link-row">
            <span className="login-link-muted">Already have access?</span>
            <Link to="/login" className="login-link">Sign in</Link>
          </div>
        </div>

        <div className="login-footer">
          © 2026 R A M D E S I G N W O R K S — Authorized access only.
        </div>
      </div>
    </div>
  );
}

export default SignupPage;
